import React, { FC, PropsWithChildren, useState, useEffect } from 'react'
import { useSpring } from 'react-spring'
import { Flex } from 'rebass'
import { useMeasure } from 'react-use'
import * as StyledAnimatedContainer from './animatedContainer.styles'
import Arrow from 'icons/arrow-expand.svg'
import { H3 } from '../typography/headings'

const AnimatedContainer: FC<PropsWithChildren<{
	heading?: string
	minimumHeight?: number
	expandable?: boolean
	isOpen?: boolean
}>> = ({ heading, minimumHeight, expandable, isOpen, children }) => {
	const defaultHeight = minimumHeight || 0
	const [open, toggle] = useState(isOpen || false)
	const [ref, { height }] = useMeasure()
	const [contentHeight, setContentHeight] = useState(defaultHeight)

	useEffect(() => {
		setContentHeight(height)
		const setHeight = () => {
			setContentHeight(height)
		}
		if (window) {
			window.addEventListener('resize', setHeight)
		}
		return window.removeEventListener('resize', setHeight)
	}, [height])

	const expand = useSpring({
		height: open ? `${contentHeight + 30}px` : `${defaultHeight}px`,
	})
	const spin = useSpring({
		config: { friction: 10 },
		transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
	})

	return (
		<>
			<StyledAnimatedContainer.HeadingContainer onClick={expandable ? () => toggle(!open) : undefined}>
				{heading ? <H3>{heading}</H3> : null}
				{expandable ? (
					<StyledAnimatedContainer.ExpandButton type="button" style={spin} aria-label="expand-container">
						<Arrow />
					</StyledAnimatedContainer.ExpandButton>
				) : null}
			</StyledAnimatedContainer.HeadingContainer>
			<Flex justifyContent="center" flexDirection="column">
				<StyledAnimatedContainer.Accordion style={expand}>
					<StyledAnimatedContainer.Content ref={ref}>{children}</StyledAnimatedContainer.Content>
				</StyledAnimatedContainer.Accordion>
			</Flex>
		</>
	)
}

AnimatedContainer.defaultProps = {
	isOpen: true,
	expandable: true,
	minimumHeight: 0,
}

export default AnimatedContainer
